import React, { useState, useContext } from 'react';
import DialogBox from './DialogBox';
import { ITEM_SHARE, CANCEL_BUTTON } from 'constants/constant';
import RBSnackbar from 'components/Shared/RBSnackbar';
import { postData } from 'service/postData.service';
import APIURLPATH from 'constants/apiconstants';
import { UserPortalContext } from 'context/appcontext';
import { trackEventInfo } from 'helper/analytics';
import { EVENTS, ACTION_ON, PAGE_ID } from 'constants/tracker';

export default function ItemShareTnCDialog({ open, onClose, otherProps }) {
	const portalUserContext = useContext(UserPortalContext);
	const { updateItemShareAccepted, userDetails } = portalUserContext;
	const { companyName, loginId } = userDetails?.result;
	const request = { companyName, loginId };

	const [openSnackbar, setOpenSnackbar] = useState({ open: false, msg: '', type: 'error' });

	const TermsCondition = () => {
		const dialogProps = {
			title: ITEM_SHARE.TERMS_CONDITION_TITLE,
			bodyContent: ITEM_SHARE.TERMS_CONDITION_BODY,
			secondaryBtnText: CANCEL_BUTTON,
			primaryBtnText: ITEM_SHARE.I_ACCEPT,
			onSecondaryClick: () => {
				onClose({ status: 'NOT_ACCEPTED', otherProps });
			},
			onPrimaryClick: async () => {
				request['requestBody'] = { itemShareAccepted: true };
				const response = await postData(APIURLPATH.ITEM_SHARE, request);
				if (response?.statusCode >= 400) {
					setOpenSnackbar({
						open: true,
						msg: 'Network Failure. Please try again.',
						type: 'error'
					});
					onClose({ status: 'NOT_ACCEPTED', otherProps });
					return;
				}

				onClose({ status: 'ACCEPTED', otherProps });
				updateItemShareAccepted(true);

				// Analytics
				trackEventInfo({
					type: EVENTS.CLICK,
					actionOn: ACTION_ON.ITEM_SHARE_ACCEPTANCE,
					location: PAGE_ID.PREVIEW
				});
			},
			showTextBox: false
		};
		return <DialogBox open={open} {...dialogProps} />;
	};
	return (
		<>
			<TermsCondition />
			<RBSnackbar
				doOpen={openSnackbar.open}
				msg={openSnackbar.msg}
				type={openSnackbar.type}
				doClose={() => {
					setOpenSnackbar({ open: false, msg: '' });
				}}
			/>
		</>
	);
}
